(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sale-shopping-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const publish = (name, data) => {
      if (window.Shopify?.designMode) return;
      try {
        const result = window.Shopify?.analytics?.publish?.(name, data);
        if (result?.catch) result.catch(() => {});
      } catch {}
    };
    const initialize = (scope) => {
      scope.querySelectorAll('[data-sale-guide]').forEach((guide) => {
        if (guide.dataset.initialized) return;
        guide.dataset.initialized = 'true';
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          publish('rocksolar:sale_guide_viewed', { collection: guide.dataset.saleCollection });
          observer.disconnect();
        }, { threshold: 0.25 });
        observer.observe(guide);
        const offer = guide.querySelector('[data-sale-offer]');
        if (offer) {
          const expires = Number(offer.dataset.saleExpiry) * 1000;
          const hideExpired = () => { if (Date.now() >= expires) offer.hidden = true; };
          hideExpired();
          const remaining = expires - Date.now();
          if (remaining > 0 && remaining < 2147483647) setTimeout(hideExpired, remaining);
          document.addEventListener('visibilitychange', hideExpired);
          const offerObserver = new IntersectionObserver((entries) => {
            if (offer.hidden || !entries.some((entry) => entry.isIntersecting)) return;
            publish('rocksolar:sale_offer_viewed', { collection: guide.dataset.saleCollection });
            offerObserver.disconnect();
          }, { threshold: 0.5 });
          offerObserver.observe(offer);
        }
        guide.addEventListener('click', (event) => {
          const link = event.target.closest('[data-sale-action]');
          if (!link || !guide.contains(link)) return;
          publish('rocksolar:sale_action_clicked', { action: link.dataset.saleAction, collection: guide.dataset.saleCollection, category: link.dataset.saleCategory || null });
        });
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('variant-box-contents')) {
    customElements.define(
      'variant-box-contents',
      class VariantBoxContents extends HTMLElement {
        connectedCallback() {
          this.output = this.querySelector('[data-variant-box-output]');
          this.fallback = this.querySelector('[data-product-box-fallback]');
          this.variantTemplates = new Map(
            [...this.querySelectorAll('template[data-variant-box-template]')].map((template) => [
              template.dataset.variantId,
              template
            ])
          );

          this.subscribeToVariantChanges = () => {
            if (!window.FoxTheme?.pubsub || this.unsubscribe) return;
            this.unsubscribe = FoxTheme.pubsub.subscribe(
              FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
              ({ data }) => {
                const source = document.querySelector('product-info[data-update-url="true"]');
                if (String(data.sectionId) === source?.dataset.section) this.update(data.variant?.id);
              }
            );
          };

          if (document.readyState === 'complete') {
            this.subscribeToVariantChanges();
          } else {
            window.addEventListener('load', this.subscribeToVariantChanges, { once: true });
          }
        }

        disconnectedCallback() {
          window.removeEventListener('load', this.subscribeToVariantChanges);
          this.unsubscribe?.();
        }

        update(variantId) {
          if (!this.output || !variantId) return;
          const template = this.variantTemplates.get(String(variantId)) || this.fallback;
          if (!template) return;
          this.output.replaceChildren(template.content.cloneNode(true));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
